import React, { useState, useEffect, useRef } from "react";
import "./PDFViewer.css";
import "./CommentLetter.css";
import API from "@safecv/api";
import * as qs from "query-string";
import WebViewer from "@pdftron/webviewer";
import { TOKEN_SESSION_ATTRIBUTE_NAME } from "@safecv/shared/appConstant";


const SupportPDFViewer = (props) => {

  const { jobId, viewType } = props;

  const urlSearch = qs.parse(window.location.search);

  const viewer = useRef(null); 
  const [id, setid] = useState(urlSearch.id);
  const [instance, setInstance] = useState(null);
  const [extension, setExtension] = useState('pdf');
  const [pageLayout, setPageLayout] = useState("SinglePage");
  const [fullScreenButton, setFullScreenButton] = useState(false);
  const [pageTransition, setPageTransition] = useState("Continuous");
  

  useEffect(()=>{  
    var str = props.currentDocVal &&  props.currentDocVal.split('(').pop().split(')')[0]; 
    setExtension(str.substring(1).toLowerCase())
  },[props.currentDocVal])

  useEffect(() => {
    if (instance && viewType) {
      instance.UI.loadDocument(
        API.DATATABLE_DOWNLOAD +
          "plan/" +
          jobId +
          "?download=supportingdoc&id=" +
          id,
        {
          filename: props.currentDocVal + "." + extension,
          customHeaders: {
            Authorization: localStorage.getItem(TOKEN_SESSION_ATTRIBUTE_NAME),
          },
        }
      );
    }
  }, [instance]);

  //To handle the layouts of the pdftron manually as viewControlsOverlay is moved to header
  useEffect(() => {
    if (pageLayout && instance) {
      const LayoutMode = instance.UI.LayoutMode;
      if (pageTransition === "Pagebypage") {
        if (pageLayout === "SinglePage") {
          instance.UI.setLayoutMode(LayoutMode.Single);
        } else if (pageLayout === "DoublePage") {
          instance.UI.setLayoutMode(LayoutMode.Facing);
        }
      }
      else if (pageTransition === "Continuous") {
        if (pageLayout === "SinglePage") {
          instance.UI.setLayoutMode(LayoutMode.Continuous);
        } else if (pageLayout === "DoublePage") {
          instance.UI.setLayoutMode(LayoutMode.FacingContinuous);
        }
      }
    } else if (pageLayout === null && instance) {
      const LayoutMode = instance.UI.LayoutMode;
      if (pageTransition === "Pagebypage") {
        instance.UI.setLayoutMode(LayoutMode.Single);
      } else if (pageTransition === "Continuous") {
        instance.UI.setLayoutMode(LayoutMode.Continuous);
      }
    }
  }, [pageLayout, pageTransition])

  //To handle the toggling of the fullscreen button and its functionality
  useEffect(() => {
    if (instance) {
      instance.UI.setHeaderItems(function (header) {
        header.getHeader("default").delete(15);
        var myCustomFullScreenButton = {
          type: "actionButton",
          title: `${fullScreenButton ? "Exit Full Screen" : "Full Screen"}`,
          dataElement: "fullscreenButton",
          onClick: function () {
            instance.UI.toggleFullScreen();
            setFullScreenButton(!fullScreenButton);
          },
          img: fullScreenButton
            ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - full screen - exit</title><path class="cls-1" d="M9.5,2H7V7H2V9.5H9.5ZM7,22H9.5V14.5H2V17H7Zm15-7.5H14.5V22H17V17h5ZM22,7H17V2H14.5V9.5H22Z"></path></svg>'
            : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - full screen</title><path class="cls-1" d="M4.22,4.22H9.78V2H2V9.78H4.22ZM9.78,19.78H4.22V14.22H2V22H9.78ZM22,14.22H19.78v5.56H14.22V22H22ZM19.78,9.78H22V2H14.22V4.22h5.56Z"></path></svg>',
        };
        header.push(myCustomFullScreenButton);
      });
    }
  }, [fullScreenButton, instance]);

  //To change the icon of fullscreen when escape key is pressed in fullscreen mode
  useEffect(() => {
    function handleFullScreenChange() {
      if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        setFullScreenButton(false);
      }
    }
    window.addEventListener("fullscreenchange", handleFullScreenChange);
    return () => window.removeEventListener("fullscreenchange", handleFullScreenChange);
  }, [fullScreenButton]);

  useEffect(() => {
    WebViewer(
      {
        initialDoc: "",
        useDownloader: false,
        path: "/webviewer/lib", 
      },
      viewer.current
    ).then(async (instance) => {

      const { Core, UI } = instance;
      const { documentViewer, annotationManager } = Core;

      setInstance(instance);

      const docViewer = documentViewer;
      docViewer.setFitMode(docViewer.FitMode.FitWidth);

      const annotManager = annotationManager;
      annotManager.enableReadOnlyMode()

      //Toolbar Customization
      instance.UI.setHeaderItems(function (header) {

        const items = header.getItems();

        //Bringing the viewControlsOverlay to pdftron header
        items.splice(2, 1,
          {
            type: 'statefulButton',
            initialState: 'continuousPageTransition',
            states: {
              continuousPageTransition: {
                title: "Continuous Page",
                img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page transition - continuous page - line</title><path class="cls-1" d="M20,2V9a2,2,0,0,1-2,2H6A2,2,0,0,1,4,9V2H6V9H18V2Zm0,17.94s0,0,0,.06v2H18V21H13a1,1,0,0,1-1-1V15H6v7H4V15a2,2,0,0,1,2-2h7.06l.26.05.09,0a1.17,1.17,0,0,1,.3.19l6,6a1.17,1.17,0,0,1,.19.3.36.36,0,0,1,0,.09A2,2,0,0,1,20,19.94Z"></path></svg>',
                onClick: () => {
                  setPageTransition("Continuous");
                },
              },
              defaultPageTransition: {
                title: "Page by Page",
                img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page transition - page by page - line</title><path class="cls-1" d="M17,17V7.83s0,0,0,0a1.7,1.7,0,0,0,0-.22l0-.07a.82.82,0,0,0-.16-.25l-5-5a.82.82,0,0,0-.25-.16l-.08,0-.21,0H5.34A1.67,1.67,0,0,0,3.67,3.67V17a1.67,1.67,0,0,0,1.67,1.67h10A1.67,1.67,0,0,0,17,17ZM5.67,4h4.66V7.83a.84.84,0,0,0,.84.83H15v8H5.67ZM20.33,9.51V20.33A1.67,1.67,0,0,1,18.66,22H11.17V20h7.16V9.51Z"></path></svg>',
                onClick: () => {
                  setPageTransition("Pagebypage");
                },
              }
            },
            mount: update => {
              const pageTransitionState = pageTrans => {
                if (instance.UI.getLayoutMode() === "Continuous" || instance.UI.getLayoutMode() === "FacingContinuous") {
                  return 'defaultPageTransition';
                } else if (instance.UI.getLayoutMode() === "Single" || instance.UI.getLayoutMode() === "Facing") {
                  return 'continuousPageTransition';
                }
              };
              docViewer.addEventListener('displayModeUpdated.dualPageTransitionButton', layoutMode => {
                update(pageTransitionState(layoutMode));
              });
            },
            unmount: () => {
              docViewer.removeEventListener('displayModeUpdated.dualPageTransitionButton');
            },
            dataElement: 'dualPageTransitionButton',
          },
          {
            type: "actionButton",
            title: "Rotate Clockwise",
            dataElement: "rotateClockwiseButton",
            onClick: function () {
              docViewer.rotateClockwise();
            },
            img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page rotation - clockwise - line</title><path class="cls-1" d="M22,7.83,18.67,12,15.33,7.83h2.43a5,5,0,0,0-4.93-4.16V2a6.64,6.64,0,0,1,6.61,5.83ZM14,12.2s0,0,0,.05V20.5A1.5,1.5,0,0,1,12.5,22h-9A1.5,1.5,0,0,1,2,20.5V8.5A1.5,1.5,0,0,1,3.5,7H8.8a.65.65,0,0,1,.19,0l.07,0a.86.86,0,0,1,.22.15l4.5,4.5a.66.66,0,0,1,.15.22s0,.05,0,.07A.65.65,0,0,1,14,12.2ZM12,20V13H8.75A.76.76,0,0,1,8,12.25V9H4V20Z"></path></svg>'
          },
          {
            type: "actionButton",
            title: "Rotate Counterclockwise",
            dataElement: "rotateCounterClockwiseButton",
            onClick: function () {
              docViewer.rotateCounterClockwise();
            },
            img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page rotation - counterclockwise - line</title><path class="cls-1" d="M22.39,11.17H20.72a5,5,0,0,0-4.17-4.93V8.67L12.39,5.33,16.55,2V4.56a6.66,6.66,0,0,1,5.84,6.61Zm-8,1s0,0,0,.05V20.5a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5V8.5A1.5,1.5,0,0,1,3.89,7H9.18a.71.71,0,0,1,.2,0l.07,0a1.07,1.07,0,0,1,.22.15l4.5,4.5a.86.86,0,0,1,.15.22.19.19,0,0,0,0,.07A1.29,1.29,0,0,1,14.38,12.2Zm-2,7.8V13H9.14a.75.75,0,0,1-.75-.75V9h-4V20Z"></path></svg>'
          },
          {
            type: 'statefulButton',
            initialState: 'singleLayout',
            states: {
              singleLayout: {
                title: "Single Page",
                img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page layout - single page - line</title><path class="cls-1" d="M20,8.94a2,2,0,0,0,0-.26.36.36,0,0,0,0-.09,1.17,1.17,0,0,0-.19-.3l-6-6a1.17,1.17,0,0,0-.3-.19l-.09,0L13.06,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V9S20,9,20,8.94ZM6,20V4h6V9a1,1,0,0,0,1,1h5V20Z"></path></svg>',
                onClick: () => {
                  setPageLayout("SinglePage");
                },
              },
              doubleLayout: {
                title: "Double Page",
                img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page layout - double page - line</title><path class="cls-1" d="M11,10.13s0,0,0-.05a1,1,0,0,0-.11-.17L7.46,6.54a.57.57,0,0,0-.16-.11l-.06,0-.14,0h-4A1.12,1.12,0,0,0,2,7.5v9a1.12,1.12,0,0,0,1.13,1.12H9.88A1.12,1.12,0,0,0,11,16.5V10.28A.4.4,0,0,0,11,10.13ZM3.13,16.5v-9H6.5v2.81a.57.57,0,0,0,.56.57H9.88V16.5ZM22,10.28a.4.4,0,0,0,0-.15s0,0,0-.05a1,1,0,0,0-.11-.17L18.46,6.54a.57.57,0,0,0-.16-.11l-.06,0-.14,0h-4A1.12,1.12,0,0,0,13,7.5v9a1.12,1.12,0,0,0,1.13,1.12h6.74A1.12,1.12,0,0,0,22,16.5V10.28ZM14.13,16.5v-9H17.5v2.81a.57.57,0,0,0,.56.57h2.81V16.5Z"></path></svg>',
                onClick: () => {
                  setPageLayout("DoublePage");
                },
              }
            },
            mount: update => {
              const pageLayoutState = pageTrans => {
                if (instance.UI.getLayoutMode() === "Continuous" || instance.UI.getLayoutMode() === "Single") {
                  return 'doubleLayout';
                } else if (instance.UI.getLayoutMode() === "Facing" || instance.UI.getLayoutMode() === "FacingContinuous") {
                  return 'singleLayout';
                }
              };
              docViewer.addEventListener('displayModeUpdated.dualPageLayoutButton', layoutMode => {
                update(pageLayoutState(layoutMode));
              });
            },
            unmount: () => {
              docViewer.removeEventListener('displayModeUpdated.dualPageLayoutButton');
            },
            dataElement: 'dualPageLayoutButton',
          }
        )

        //Adding a divider after pan
        items.splice(9, 1,
          {
            type: 'divider',
          },
        )

        header.update(items);

      });

      //disbling certain elements from pdftron
      UI.disableElements([
        "ribbons",
        "menuButton",
        "searchButton",
        "selectToolButton",
        "toggleNotesButton",
      ]);

    });
  }, []);

  // It renders support doc.
  return (
    <div className="landing-pdf-container">
      <div className="webviewer webViewerHeight" ref={viewer}></div>
    </div>
  );
};

export default SupportPDFViewer;